module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('ul', {
    staticClass: "nav navbar-nav navbar-left",
    attrs: {
      "slot": "toolbar_buttons"
    },
    slot: "toolbar_buttons"
  }, [_c('li', [_c('date-range-picker', {
    attrs: {
      "datesRange": _vm.datesRange
    },
    on: {
      "dates-range-updated": _vm.updatedDates
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 main",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "col-xs-12 spinner-container"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading && _vm.error) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "well"
  }, [_vm._v(_vm._s(_vm.message))])])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.error) ? _c('div', {
    staticClass: "row ls-charts"
  }, [_c('h1', [_vm._v("Model Analytics")]), _vm._v(" "), (!_vm.models.length) ? _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "well"
  }, [_vm._v("There is no data available for this account")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.models), function(model) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('h3', [_c('span', [(model.active) ? _c('i', {
      staticClass: "fa fa-check"
    }) : _vm._e()]), _vm._v(_vm._s(model.name) + " "), _c('small', [_vm._v(_vm._s(_vm._f("formatDate")(model.created)))])]), _vm._v(" "), (model.empty) ? _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "well"
    }, [_vm._v("There is no data available for this period of time")])]) : _vm._e(), _vm._v(" "), (!model.empty) ? _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('h3', [_vm._v("Scored")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "metrics-banner-text text-center"
    }, [_vm._v(_vm._s(model.stats.scored))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('h3', [_vm._v("Conversions")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "metrics-banner-text text-center"
    }, [_vm._v(_vm._s(model.stats.converters))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('h3', [_vm._v("Conv. Rate")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "metrics-banner-text text-center"
    }, [_vm._v(_vm._s(_vm._f("percentage")(model.stats.conv_rate, 2)))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('h3', [_vm._v("Delta")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "metrics-banner-text text-center"
    }, [_vm._v("\n                  " + _vm._s(_vm._f("decimal")(model.stats.delta)) + "\n                ")])])])])]), _vm._v(" "), (model.grading_engine) ? [_c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('h3', [_vm._v("Baseline Stats")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('tr', _vm._l((model.grading_engine.stats.baseline.header), function(h) {
      return _c('th', [_vm._v(_vm._s(h))])
    }), 0)]), _vm._v(" "), _c('tbody', _vm._l((model.grading_engine.stats.baseline.rows), function(r) {
      return _c('tr', {
        class: {
          grade: r[0]
        }
      }, [_c('th', [_vm._v(_vm._s(r[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("decimal")(r[2])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")(r[3])))])])
    }), 0)])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('h3', [_vm._v("Current Stats")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('tr', [_vm._l((model.grading_engine.stats.current.header), function(h) {
      return _c('th', [_vm._v(_vm._s(h))])
    }), _vm._v(" "), _c('th', [_vm._v("Conv. Rate")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((model.grading_engine.stats.current.rows), function(r) {
      return _c('tr', {
        class: {
          grade: r[0]
        }
      }, [_c('th', [_vm._v(_vm._s(r[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("decimal")(r[2])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")(r[3])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r[4]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r[5]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")(r[5] / r[4])))])])
    }), 0)])])])])])] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('h3', [_vm._v("Analysis by Decile")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Decile")]), _vm._v(" "), _vm._l((model.deciles.header), function(h) {
      return _c('th', [_vm._v(_vm._s(h))])
    })], 2)]), _vm._v(" "), _c('tbody', _vm._l((model.deciles.rows), function(r) {
      return _c('tr', [_c('th', [_vm._v(_vm._s(r.key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.data[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.data[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.data[2]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")(r.data[3], 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")(r.data[4], 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")(r.data[5], 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")(r.data[6], 2)))])])
    }), 0)])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-lg-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('h3', [_vm._v("Distribution by Decile")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "col-xs-12 chart-wrapper"
    }, [_c('ls-chart', {
      attrs: {
        "target-css-classes": "chart",
        "target-id": 'dist_chart_' + model.id,
        "bc-data": model.distribution_by_decile.series,
        "bc-layout": model.distribution_by_decile.layout
      }
    })], 1)])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-lg-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('h3', [_vm._v("Conv. Rate by Decile")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "col-xs-12 chart-wrapper"
    }, [_c('ls-chart', {
      attrs: {
        "target-css-classes": "chart",
        "target-id": 'conv_chart_' + model.id,
        "bc-data": model.conv_rate_by_decile.series,
        "bc-layout": model.conv_rate_by_decile.layout
      }
    })], 1)])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-lg-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('h3', [_vm._v("Capture rate")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "col-xs-12 chart-wrapper"
    }, [_c('ls-chart', {
      attrs: {
        "target-css-classes": "chart",
        "target-id": 'capture_' + model.id,
        "bc-data": model.capture_rate.series,
        "bc-layout": model.capture_rate.layout
      }
    })], 1)])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-lg-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('h3', [_vm._v("Score Delta")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "col-xs-12 chart-wrapper"
    }, [_c('ls-chart', {
      attrs: {
        "target-css-classes": "chart",
        "target-id": 'delta_' + model.id,
        "bc-data": model.score_delta.series,
        "bc-layout": model.score_delta.layout
      }
    })], 1)])])])])], 2) : _vm._e()])
  })], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72d8e4b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/ModelAnalytics.vue
// module id = 666
// module chunks = 0